var $bdd847d8beb08799$exports = {};
$bdd847d8beb08799$exports = {
    "alpha": `Alpha`,
    "blue": `Blau`,
    "brightness": `Helligkeit`,
    "green": `Gr\xfcn`,
    "hue": `Farbton`,
    "lightness": `Leuchtkraft`,
    "red": `Rot`,
    "saturation": `S\xe4ttigung`
};


export {$bdd847d8beb08799$exports as default};
//# sourceMappingURL=de-DE.module.js.map
